import React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';

import styles from './list-view-infinite-loading.module.css';

export function ListViewInfiniteLoading() {
    return (
        <div className={styles['list-view-infinite-loading']}>
            <LoadingIcon size={32} />
        </div>
    );
}
